module.exports = __webpack_public_path__ + "img/zanwujiangyi@2x.19226a26.png";